import { render } from "./PropertyApp.vue?vue&type=template&id=3625ef77&scoped=true"
import script from "./PropertyApp.vue?vue&type=script&lang=js"
export * from "./PropertyApp.vue?vue&type=script&lang=js"

import "./PropertyApp.vue?vue&type=style&index=0&id=3625ef77&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3625ef77"]])

export default __exports__